import firebase from "firebase";
const db = firebase.database();

export function FetchOneTimeCoupon(coachOrgId, couponId) {
  return new Promise(async (resolve, reject) => {
    try {
      const path = `coachOrgs/${coachOrgId}/oneTimeCoupons/${couponId}`;
      const result = await db
        .ref(path)
        .once("value")
        .then((s) => s.val());
      resolve(result);
    } catch (e) {
      reject(e);
    }
  });
}



// WEBPACK FOOTER //
// ./src/domains/PaymentDomain.js